<div class="mat-toolbar-header-container">
    <mat-toolbar class="toolbar">
        <div class="flex align-items--center">
            <img class="axtraxpro-logo" src="../../../../assets/images/Axtraxpro logo.svg" alt="Axtraxpro">

            <div (click)="toggleSidebar()"
                 [ngClass]="{'icon-Menu-toggle-Close': (sidebarSize$ | async) === SidebarSize.FULL, 'icon-Menu-toggle-Open': (sidebarSize$ | async) !== SidebarSize.FULL}">
            </div>
        </div>

        <div class="notifications">
<!--            <div class="notifications-button">-->
<!--                <mat-icon color="accent">notifications_none</mat-icon>-->
<!--            </div>-->
<!--            <div class="accent-button">-->
<!--                <mat-icon color="accent"> mail_outline</mat-icon>-->
<!--            </div>-->
<!--            <div class="theme-toggle">-->
<!--                <span class="text-span">Theme</span>-->
<!--                <mat-slide-toggle [checked]="isDarkTheme$ | async" (change)="toggleDarkTheme($event.checked)">-->
<!--                </mat-slide-toggle>-->
<!--            </div>-->
          <!-- <div class="version-content">
            {{version}}
          </div> -->
          <app-dark-mode-toggle *ngIf="showLightModeToggle"></app-dark-mode-toggle>
          <a class="help-ico" href="../../../../assets/AxTraxPro_Web_Client_User_Guide.pdf" target="_blank" >
            <app-svg [svg]="SVG_NAMES.help"></app-svg>
          </a>
          <div class="tooltip-container">
            <div class="help-tooltip">
              <div class="text">{{'header.userManual' | translate}}</div>
            </div>
          </div>
          <div class="button button__light-blue" (click)="logoutUser()">
              <div class="icon-lock-down"></div>
              <div>{{'header.signOut' | translate}}</div>
          </div>

        </div>
    </mat-toolbar>
</div>
